import React from 'react';
import {SearchField, DataGrid, Dialog, IconMenu, FilterMenu, Text} from 'components/core';
import {Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import {ProcedureItemsCtx} from 'components/dataProviders/procedureItems';
import {ItemCategoryLabel, ItemDrawer} from 'components/procedures/items';
import EditDialog from './dialog';

const overrideStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    toolbar: {
        padding: 24,
        height: 88,
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 88,
        '& .MuiGrid-item':
        {
            height: 40
        },
        '& .MuiTypography-root':
        {
            lineHeight: '40px'
        }
    },
    datagrid: {
        height: 'calc(100% - 88px)'
    },
    searchbox: {
        height: 40,
        width: 300
    }
  }), {name: "RaymanDataGrid"});


const columns = {
    name: { 
        field: 'name',
        headerName: 'Nombre del item',
        flex: 1
    },
    category: {
        field: 'categoryID',
        headerName: 'Categoría',
        flex: 0.5,
        renderCell: (params) => {
            return <ItemCategoryLabel categoryID={params.value} />
        }
    },
    icon: {
        field: 'iconID',
        headerName: 'Icono',
        flex: 0.5,
        renderCell: (params) => {            
            return <ItemDrawer itemID={params.row.itemID} />
        }
    }
}

const collapsedColumns = [columns.name, columns.category];
const extendedColumns = [columns.name, columns.category, columns.icon];

function RowMenu({row, handleEdit})
  {
      const ctx = React.useContext(ProcedureItemsCtx);
      const [open, setOpen] = React.useState(false);
      const [loading, setLoading] = React.useState(false);
  
      const handleClose = () => {
          setOpen(false);
      }
  
      const handleOpen = () => {
          setOpen(true);
      }
  
      const handleConfirm = () => {
          setLoading(true);
          ctx.funcs.delete(row.itemID).then(() => {
              setLoading(false);
              setOpen(false);
          });
      }
  
      let items = [
        {
            label: "Editar",
            onClick: () => handleEdit()
        },
        {
            label: "Borrar",
            onClick: () => handleOpen(),
            danger: true
        } 
      ];
      return <>
      <Dialog title="Eliminar item" open={open} loading={loading} confirm="Eliminar" confirmColor="error" cancel="Cancelar" onConfirm={handleConfirm} onCancel={handleClose} onClose={handleClose}>
          ¿Está seguro? Una vez borrado no se podrá recuperar
        </Dialog>
      <IconMenu items={items} />
      </>
  }


export default function ItemsList({onRowSelected = () => {}, collapsed = false})
{
    const classes = overrideStyle();
    const itemsCtx = React.useContext(ProcedureItemsCtx);
    const [data, setData] = React.useState(itemsCtx.items.array);
    const [filters, setFilters] = React.useState({text: '', tags: []});
    const [gridColumns, setGridColumns] = React.useState([]);
    const [filterTags, setFilterTags] = React.useState([]);
    const [editDialogState, setEditDialogState] = React.useState({open: false, itemID: null});

    let searchTimeout = 0;

    const menuColumn = React.useMemo(() => ({
        field: 'menu',
        headerName: ' ',
        width: 40,
        align: 'center',
        disableClickEventBubbling: true,
        renderCell: (params) => {
            return <RowMenu row={params.row} handleEdit={() => setEditDialogState({open: true, itemID: params.row.itemID})}/>
        }
    }), [setEditDialogState]);

    React.useEffect(function filterData(){
        
        let tmpData = [...itemsCtx.items.array];
        
        // apply filters
        tmpData = tmpData.filter((value) => {
            let result = true;
            if(filters.text) result &= value.name.toLowerCase().includes(filters.text);
            if(filters.tags.length > 0) result &= value.tags.some(r => filters.tags.includes(r));
            return result;
        });

        setData(tmpData);
    }, [itemsCtx, filters]);

    React.useEffect(function initializeFilterTags() {
        let tags = [];
        itemsCtx.categories.data.array.forEach((item) => tags.push({value: item.categoryID, text: item.name}));

        setFilterTags(tags);
    }, [itemsCtx]);

    React.useEffect(function handleColumns(){
        let gridCols = collapsed ? [...collapsedColumns, menuColumn] : [...extendedColumns, menuColumn];
        setGridColumns(gridCols);
    }, [collapsed, menuColumn]);

    const handleSelectRow = (row) =>
    {
        // onRowSelected(row);
    }

    const handleSearchChange = (value) =>
    {
        if(searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            let tmpFilters = {...filters};
            tmpFilters.text = value;
            if(tmpFilters.text !== filters.text) setFilters(tmpFilters);
        }, 300);
    }

    const handleTagsChange = React.useCallback((tags) => {
        let tmpFilters = {...filters};
        tmpFilters.tags = tags;
        
        if(tmpFilters.tags.join(",") !== filters.tags.join(","))
        {
            setFilters(tmpFilters);
        }
        
    }, [filters]);

    function handleEditDialogClose()
    {
        setEditDialogState({open: false, itemID: null});
    }

    return <>
        <EditDialog open={editDialogState.open} handleClose={()=>handleEditDialogClose()} itemID={editDialogState.itemID} />
        <Grid container direction="row" justify="space-between" className={classes.toolbar}>
            <Grid item><SearchField className={classes.searchbox} onChange={handleSearchChange} /></Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-end" spacing={2}>
                    <Grid item><Text>Filtros:</Text> </Grid>
                    <Grid item><FilterMenu label={"Categorías"} items={filterTags} onChange={handleTagsChange}/></Grid>
                </Grid> 
            </Grid>
        </Grid>
        <DataGrid 
        rows={data}
        columns={gridColumns}
        onRowSelected = {(row) => handleSelectRow(row.data)}
        loading={itemsCtx.loading}
        density="comfortable"
        className={classes.datagrid}
        />
    </>
}